import React from 'react';
import { Table, Button } from 'semantic-ui-react';


const PropertyTable = ({
    organizationalUnitProperties, activateEditRequest, writePrivilege, switchToDetails, getSortedOrganizationalUnitProperties, fieldName, direction
}) => (
    <Table celled selectable sortable>
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell
                    sorted={fieldName === 'orgUnit' ? direction : null}
                    onClick={() => getSortedOrganizationalUnitProperties('orgUnit', 'name')}
                >Organizaciona jedinica</Table.HeaderCell>
                <Table.HeaderCell
                    sorted={fieldName === 'property' ? direction : null}
                    onClick={() => getSortedOrganizationalUnitProperties('property', 'name')}
                >Naziv imovine</Table.HeaderCell>
                <Table.HeaderCell
                    sorted={fieldName === 'rightType' ? direction : null}
                    onClick={() => getSortedOrganizationalUnitProperties('rightType', 'name')}
                >Tip prava</Table.HeaderCell>
                {writePrivilege &&
                <Table.HeaderCell></Table.HeaderCell>
                }
            </Table.Row>
        </Table.Header>

        <Table.Body>
            {organizationalUnitProperties.map(el =>
                (
                    <Table.Row key={el.id}>
                        <Table.Cell onClick={() => switchToDetails(el)}>{el.organizationalUnit.name}</Table.Cell>
                        <Table.Cell onClick={() => switchToDetails(el)}>{el.property.name}</Table.Cell>
                        <Table.Cell onClick={() => switchToDetails(el)}>{el.rightType.name}</Table.Cell>
                        {writePrivilege &&
                        <Table.Cell verticalAlign="middle" className="text-center" >
                            <Button
                                basic
                                color="green"
                                size="small"
                                onClick={() => activateEditRequest(el)}
                            >
                                Uredi
                            </Button>
                            {
                            // <Button
                            //     basic
                            //     color="red"
                            //     size="small"
                            //     circular
                            //     icon="delete"
                            // />
                            }
                        </Table.Cell>
                        }
                    </Table.Row>
                ))
            }
        </Table.Body>
    </Table>
);

export default PropertyTable;



// WEBPACK FOOTER //
// ./src/views/Assets/Property/PropertyTable.js